'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _portal = require('../portal');

var _portal2 = _interopRequireDefault(_portal);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _divider = require('../divider');

var _divider2 = _interopRequireDefault(_divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** Pop over useful for showing tooltips or menu options */
var PopOver = function PopOver(_ref) {
  var children = _ref.children,
      header = _ref.header,
      style = _ref.style,
      headerStyle = _ref.headerStyle,
      open = _ref.open,
      popOverRef = _ref.popOverRef,
      position = _ref.position,
      secondaryMenuItems = _ref.secondaryMenuItems,
      dividerText = _ref.dividerText,
      dividerStyle = _ref.dividerStyle,
      onHeaderClick = _ref.onHeaderClick,
      custom = _objectWithoutProperties(_ref, ['children', 'header', 'style', 'headerStyle', 'open', 'popOverRef', 'position', 'secondaryMenuItems', 'dividerText', 'dividerStyle', 'onHeaderClick']);

  if (!open) {
    return null;
  }

  var divider = null;

  if (secondaryMenuItems) {
    divider = _react2.default.createElement(_divider2.default, { style: dividerStyle });
  }

  if (secondaryMenuItems && dividerText) {
    divider = _react2.default.createElement(_divider2.default, { text: dividerText, style: dividerStyle });
  }

  return _react2.default.createElement(
    _portal2.default,
    null,
    _react2.default.createElement(
      'section',
      _extends({
        style: _getStyles2.default.root(position, style),
        ref: popOverRef
      }, custom),
      header ? _react2.default.createElement(
        'h1',
        { onClick: onHeaderClick, style: _getStyles2.default.header(headerStyle) },
        header
      ) : null,
      children,
      divider,
      secondaryMenuItems
    )
  );
};

PopOver.displayName = 'PopOver';

PopOver.propTypes = {
  /** Content of the PopOver */
  children: _propTypes2.default.node.isRequired,
  /** Optional header text */
  header: _propTypes2.default.node,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Toggle the PopOvers visibility */
  open: _propTypes2.default.bool,
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Ref to the PopOver */
  popOverRef: _propTypes2.default.func.isRequired,
  /** The PopOver's position relative to the anchor */
  position: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Secondary set of MenuItems */
  secondaryMenuItems: _propTypes2.default.node,
  /** Text to divide the menu items */
  dividerText: _propTypes2.default.node,
  /** Override the styles of the divider element */
  dividerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when the PopOver's header is clicked
   *
   * function(event: object) => void
   */
  onHeaderClick: _propTypes2.default.func
};

PopOver.defaultProps = {
  header: null,
  style: {},
  headerStyle: {},
  open: false,
  position: {},
  secondaryMenuItems: null,
  dividerText: null,
  dividerStyle: {},
  onHeaderClick: null
};

exports.default = (0, _radium2.default)(PopOver);
module.exports = exports.default;